import item1 from "../Images/cookies.jpg";
import item2 from "../Images/milk.jpg";
import item3 from "../Images/wheat-flour.jpg";
import item4 from "../Images/rice.jpg";
import item5 from "../Images/bread.jpg";
import item6 from "../Images/coffee.jpeg";

export const MarketData = [
  {
    id: 1,
    image: item1,
    title: "Sweet Cookies",
    desc: "",
    price: 150,
    type: "product",
  },
  {
    id: 2,
    image: item2,
    title: "Cow Milk 1L",
    desc: "",
    price: 100,
    type: "product",
  },
  {
    id: 3,
    image: item3,
    title: "Wheat flour fresh",
    desc: "",
    price: 120,
    type: "product",
  },
  {
    id: 4,
    image: item4,
    title: "Rice 1Kg",
    desc: "",
    price: 40,
    type: "product",
  },
  {
    id: 5,
    image: item5,
    title: "Bread",
    desc: "",
    price: 50,
    type: "product",
  },
  {
    id: 6,
    image: item6,
    title: "Coffee",
    desc: "",
    price: 120,
    type: "product",
  },
];
